import { createFileRoute, Link } from '@tanstack/react-router';
import { DiagramBoard } from '@/components/diagrams/DiagramBoard';
import { localCards } from '@/content/mobile';
import { DIAGRAMS } from '@/lib/diagram-layouts';
import { useLearnerPreferences } from '@/providers/LearnerPreferences';
import { typeScale } from '@/lib/typography';

export const Route = createFileRoute('/app/diagrams/$slug')({ component: DiagramPage });

function DiagramPage() {
  const { slug } = Route.useParams();
  const preferences = useLearnerPreferences();
  const spec = DIAGRAMS[slug] ?? DIAGRAMS['body-parts'];
  const terms = localCards(spec.moduleSlug, preferences.dialect, preferences.baseLanguage);
  return (
    <div className="mx-auto max-w-5xl px-5 py-8 sm:px-8 lg:py-12">
      <Link to="/app/resources" className="font-bold text-[#2d7a13]">← Learning Hub</Link>
      <h1 className={`mt-8 ${typeScale.screenTitle}`}>{spec.title}</h1>
      <p className="mt-3 text-slate-600">Tap a term on the diagram to hear it pronounced.</p>
      <DiagramBoard slug={spec.image} terms={terms} voice={preferences.voice} />
    </div>
  );
}
